
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '~/app/shared';
import { StepFiveComponent } from './steps/step-five/step-five.component';
import { StepFourComponent } from './steps/step-four/step-four.component';
import { StepOneComponent } from './steps/step-one/step-one.component';
import { StepSixComponent } from './steps/step-six/step-six.component';
import { StepThreeComponent } from './steps/step-three/step-three.component';
import { StepTwoComponent } from './steps/step-two/step-two.component';
import { StepsComponent } from './steps/steps.component';



@NgModule({
  declarations: [StepsComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    StepFourComponent,
    StepFiveComponent,
    StepSixComponent],
  imports: [
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FlowsModule { }
